import { render, staticRenderFns } from "./RelevanceConfig.vue?vue&type=template&id=2f781706&scoped=true"
import script from "./RelevanceConfig.vue?vue&type=script&lang=js"
export * from "./RelevanceConfig.vue?vue&type=script&lang=js"
import style0 from "./RelevanceConfig.vue?vue&type=style&index=0&id=2f781706&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f781706",
  null
  
)

export default component.exports